export const normalizePhone = (input: string): string => {
  const cleaned = input.replace(/[\s\-().]/g, '');
  if (cleaned.startsWith('+')) return cleaned;
  if (cleaned.startsWith('91') && cleaned.length === 12) return `+${cleaned}`;
  if (cleaned.length === 10) return `+91${cleaned}`;
  return cleaned;
};

export const isValidIndianMobile = (input: string): boolean => {
  if (!input || typeof input !== 'string') return false;
  const cleaned = input.replace(/[\s\-().]/g, '');
  return /^[6-9]\d{9}$/.test(cleaned);
};

export const isValidPhone = (input: string): boolean => {
  if (!input || typeof input !== 'string') return false;
  const cleaned = input.replace(/[\s\-().]/g, '');
  if (cleaned.startsWith('+')) {
    return /^\+\d{10,15}$/.test(cleaned);
  }
  if (/^\d{10,12}$/.test(cleaned)) {
    if (cleaned.length === 10 || (cleaned.length === 12 && cleaned.startsWith('91'))) {
      return true;
    }
  }
  return false;
};

export const displayPhone = (input: string): string => {
  const normalized = normalizePhone(input);
  if (normalized.startsWith('+91') && normalized.length === 13) {
    return `${normalized.slice(0, 3)} ${normalized.slice(3, 8)} ${normalized.slice(8)}`;
  }
  return normalized;
};

export const phoneToAuthEmail = (normalizedPhone: string): string => {
  const local = normalizedPhone.replace(/\D/g, '');
  return `${local}@phone.local`;
};
